import React, { ReactNode } from 'react';
import { Body, Icon, Label } from '@sato/components';

export const WaterListItem = ({
  title,
  color,
  price,
  children,
}: {
  title: string;
  color: string;
  price?: ReactNode;
  children: ReactNode;
}) => {
  return (
    <div key={title}>
      <Label component="p" className="!text-3">
        {title}
      </Label>

      <div className="mt-2 flex items-center">
        <Icon icon="water24" className="mr-2 text-6" style={{ color }} />

        <Body>{children}</Body>
      </div>

      {price && (
        <div className="mt-2 flex items-center">
          <Icon icon="water24" className="mr-2 text-6" style={{ color }} />

          <Body>{price}</Body>
        </div>
      )}
    </div>
  );
};
